import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductStickyBuyBarComponent } from '../../../app/content/modules/page/components/product/components/product-sticky-buy-bar/product-sticky-buy-bar.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct, createDiscountedProduct, createLastBottlesProduct } from '../../_mocks/wine-product.mock';

const meta: Meta<ProductStickyBuyBarComponent> = {
  title: 'Organisms/Product/Sticky Buy Bar',
  component: ProductStickyBuyBarComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'fullscreen',
  },
};
export default meta;
type Story = StoryObj<ProductStickyBuyBarComponent>;

export const Default: Story = {
  args: { product: createDamilanoBarberaProduct() },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-sticky-buy-bar')).toBeTruthy();
  },
};

export const DiscountedProduct: Story = {
  args: { product: createDiscountedProduct() },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-sticky-buy-bar')).toBeTruthy();
  },
};

export const OutOfStock: Story = {
  args: { product: createDamilanoBarberaProduct({ inStock: false }) },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-sticky-buy-bar')).toBeTruthy();
  },
};

export const LastBottles: Story = {
  args: { product: createLastBottlesProduct() },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-sticky-buy-bar')).toBeTruthy();
  },
};
